import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class QuestionnaireService {

  constructor(private restangular: Restangular) { }

  questionnaireCRUD() {
    return this.restangular.all("quiz_masters");
  }

  getAllQuestionnaires() {
    return this.restangular.all("getAllQuestionnaires");
  }

  removeQuestionnaire(id) {
    return this.restangular.one('quiz_masters/' + id);
  }

  getQuestionnaire(id) {
    return this.restangular.one('quiz_masters/' + id);
  }

  getQuestionannireDetail(id) {
    return this.restangular.one('getQuestionannireDetail/' + id);
  }

  questionsCRUD() {
    return this.restangular.all("quiz_questions");
  }

  removeQuestion(id) {
    return this.restangular.one('quiz_questions/' + id);
  }

  answersCRUD() {
    return this.restangular.all('quiz_answers');
  }

  removeAnswer(id) {
    return this.restangular.one('quiz_answers/' + id);
  }

  getAllUserQuestionnaires() {
    return this.restangular.all("getAllUserQuestionnaires");
  }

  getQuestionannireForAttempt(id) {
    return this.restangular.one('getQuestionannireForAttempt/' + id);
  }

  attemtQuestionnaire() {
    return this.restangular.all("quiz_user_masters");
  }

  getUserAttemptQuestionnaires() {
    return this.restangular.all("getUserAttemptQuestionnaires");
  }

  getSubmitedQuestionnaire(id) {
    return this.restangular.one('getSubmitedQuestionnaire/' + id);
  }

  getQuizDashboardData(id) {
    return this.restangular.one('getQuizDashboardData/' + id);
  }

  quizBlockEmployeeCRUD(id) {
    return this.restangular.one('quiz_block_employees/' + id);
  }

  getAvialableQuestionaires() {
    return this.restangular.one('getAvialableQuestionaires');
  }

  getQuizFilterOptionData() {
    return this.restangular.one('getQuizFilterOptionData');
  }

  getQuizFormData() {
    return this.restangular.one('getQuizFormData');
  }

  getUserPendingQuestionnaires() {
    return this.restangular.all("getUserPendingQuestionnaires");
  }

  updateQuizStatus() {
    return this.restangular.all("updateQuizStatus");
  }

  sendEmail() {
    return this.restangular.all("sendQuizEmail");
  }

  validateQuizAttempt() {
    return this.restangular.all("validateQuizAttempt");
  }

  reviewQuiz() {
    return this.restangular.all("reviewQuiz");
  }

  updateQuizLog() {
    return this.restangular.all("updateQuizLog");
  }

  updateShowResults() {
    return this.restangular.all("updateShowResults");
  }

  getBlockEmployeeForQuiz() {
    return this.restangular.all("getBlockEmployeeForQuiz");
  }

  addBlockQuizEmployees() {
    return this.restangular.all("addBlockQuizEmployees");
  }

  getUserQuizAttemptedLog() {
    return this.restangular.all("getUserQuizAttemptedLog");
  }

  userQuizPdf() {
    return this.restangular.one("userQuizPdf");
  }

  getTypeheadEmployeesForQuiz() {
    return this.restangular.one("getTypeheadEmployeesForQuiz");
  }

  removeSectionQuestion(id) {
    return this.restangular.one('quiz_section_questions/' + id);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/questionnaire.service.ts